export var filterByTerm = function (list, term) {
    var normalized = term.trim().toLowerCase();
    if (normalized === '')
        return list;
    return list.filter(function (_a) {
        var title = _a.title;
        return title.toLowerCase().includes(normalized);
    });
};
